import Vue from 'vue'
import VueRouter from 'vue-router'
import { devRoutes } from './dev'

import Default from '../pages/Default.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/default'
},
{
    name: 'default',
    path: '/default',
    component: Default,
    meta: {
        layout: 'content',
    },
},
{
    name: 'page',
    path: '/pages/:page',
    component: (resolve) =>
        require(['../pages/PageViewer.vue'], resolve),
    meta: {
        layout: 'content',
    },
},
{
    name: 'page_id',
    path: '/pages/:page/:id',
    component: (resolve) =>
        require(['../pages/PageViewer.vue'], resolve),
    meta: {
        layout: 'content',
    },
},
{
    name: 'signin',
    path: '/signin',
    component: (resolve) =>
        require(['../pages/user/Signin.vue'], resolve),
    meta: {
        layout: 'blank',
    },
},
{
    name: 'signout',
    path: '/signout',
    component: (resolve) =>
        require(['../pages/user/Signout.vue'], resolve),
    meta: {
        layout: 'blank',
    },
},
{
    name: 'profile',
    path: '/profile',
    component: (resolve) =>
        require(['../pages/user/Profile.vue'], resolve),
    meta: {
        layout: 'content',
    },
},
/* V3 */
{
    name: 'password_reset',
    path: '/password_reset',
    component: (resolve) =>
        require(['../projects/nlx3/features/user/pages/PasswordReset.vue'], resolve),
    meta: {
        layout: 'blank',
    },
},
// {
//     name: 'password_reset',
//     path: '/password_reset',
//     component: (resolve) =>
//         require(['../pages/user/PasswordReset.vue'], resolve),
//     meta: {
//         layout: 'blank',
//     },
// },
/* End V3 */
{
    name: 'password_reset_verify',
    path: '/password_reset/verify/:key',
    component: (resolve) =>
        require(['../pages/user/PasswordResetForm.vue'], resolve),
    meta: {
        layout: 'blank',
    },
},
{
    name: 'registration',
    path: '/registration',
    component: (resolve) =>
        require(['../pages/user/Registration.vue'], resolve),
    meta: {
        layout: 'blank',
    },
},
{
    name: 'server-error',
    path: '/server-error',
    component: (resolve) =>
        require(['../pages/ServerError.vue'], resolve),
    meta: {
        layout: 'blank'
    }
},
{
    name: 'test',
    path: '/test',
    component: (resolve) =>
        require(['../pages/Test.vue'], resolve),
    meta: {
        layout: 'content'
    }
},
...devRoutes
]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

export default router